import {autoinject, transient} from "aurelia-framework";
import { Ajax, IAjaxResult } from "../ajax";

@autoinject
@transient()
export class FormSchemaCrudService<TInstance> implements IFormSchemaCrudService<TInstance> {
  constructor(private ajax: Ajax) { }

  public webServiceName: string;

  public getAll(init? : RequestInit): Promise<Array<TInstance> | undefined> {
      return this.ajax.fetchJson<Array<TInstance>>(`${this.webServiceName}/Get`, init)
          .then((result: IAjaxResult<Array<TInstance>>) => {
              return result.Data;
          });
  }

  /**
   *  used when reverting instance in collection
   * @param id
   */
  public get(id: number | string): Promise<TInstance | undefined> {
      return this.ajax.fetchJson<any>(`${this.webServiceName}/Get/${id}`)
          .then((result: IAjaxResult<TInstance>) => {
              return result.Data;
          });
  }

  public delete(id: number | string): Promise<IAjaxResult<void>> {
      return this.ajax.delete<void>(`${this.webServiceName}/Delete/${id}`);
  }

  /**
   * creates new instance and returns it, without persisting to the database!
   */
  public create(): Promise<TInstance | undefined> {
      return this.ajax.fetchJson<any>(`${this.webServiceName}/Create`)
          .then((result: IAjaxResult<TInstance>) => {
              return result.Data;
          });
  }

  /**
   * persists and returns new instance, with the primary key filled in
   * @param instance
   */
  public insert(instance: TInstance): Promise<IAjaxResult<TInstance>> {
      return this.ajax.post<TInstance>(`${this.webServiceName}/post`, instance );
  }

  public update(id: string | number, instance: any, propertyName: string, newValue: any, oldValue: any): Promise<IAjaxResult<TInstance>> {
      return this.ajax.put<TInstance>(`${this.webServiceName}/Put/${id}`, { instance: instance, propertyName: propertyName });
  }
}

export { IAjaxResult } from "../ajax";

export interface IFormSchemaCrudService<TInstance> {
  webServiceName: string;

  getAll(init? : RequestInit): Promise<Array<TInstance>|undefined>;

  get(id: number | string): Promise<TInstance|undefined>;

  delete(id: number | string): Promise<IAjaxResult<void>>;

  /**
   * creates new instance and returns it, without persisting to the database!
   */
  create(): Promise<TInstance|undefined>;

  /**
   * persists and returns new instance, with the primary key filled in
   * @param instance
   */
  insert(instance: any): Promise<IAjaxResult<any>>;

  update(id: string | number, instance: any, propertyName: string, newValue: any, oldValue: any): Promise<IAjaxResult<TInstance>>;
}